import { Injectable, EventEmitter } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs/Rx';
import { environment } from '../../../../environments/environment';

// Interfaces
import { IService } from '../../interfaces';

@Injectable()
export class LoaderService implements IService {
	// implements local variables
	_isLoading: BehaviorSubject<boolean> = new BehaviorSubject(false);

	_data: {
		isLoading: boolean
	}

	MembersAreLoading$ = new EventEmitter<boolean>(true);

	// implements IService
	name = 'LoaderService';
	test(name, value) {
		console.log('testing', name, value);
	}
	constructor() { }

	get ISLOADING() {
		return this._isLoading;
	}

	private set isLoading(value: boolean) {
		this._data = {
			isLoading: value
		};
		this._isLoading.next(value);
	}

	get Data() {
		if (this._data === undefined) {
			return { isLoading: false };
		}
		return this._data;
	}

	SetLoading(caller: string, value: boolean) {
		//'setting loader'.logWithObject(this.name, [{ caller: caller, value: value }]);
		this.isLoading = value;
	}

}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/services/loader/loader.service.ts